import { NavLink } from "react-router";
import { useDemandeByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function DemandeListItem({id}:{id:number}){
   const { data, error, isLoading }= useDemandeByIdQuery(id.toString());
    const {translate}=useTrads();
   
    return (
        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
        <span><NavLink to={`/demande/${data.id.toString()}`}>{data.titre}</NavLink></span>
        ):null
    )
}
export default DemandeListItem;